import React from 'react'
import classnames from 'classnames'
import { Heading, Note } from '@myxplor/ui'
import { FormCheckbox } from '@myxplor/forms'

import { daysOfWeek, isWeekend, truncateDay } from '../../../../../week'
import './update-myChild.css'

export const vacanciesForDay = (vacancies = {}, { label }) => vacancies[String(label).toLowerCase()]

const MyChildDay = ({ day, inputName, children }) => {
  return (
    <div
      className={classnames({
        weekDay: true,
        'myChildDay--vacancy': true,
        weekDay__isWeekend: isWeekend(day.value),
      })}>
      <label htmlFor={'form-input-' + inputName}>
        <h4>{truncateDay(day.label)}</h4>
      </label>
      {children}
    </div>
  )
}

const UpdateMyChildFormFields = ({ values, onChange, loading }) => (
  <div className="myChild--wrapper">
    <Heading small compact>
      Update MyChild Information and Vacancies
    </Heading>

    <Note important>
      At the end of every week Xplor will automatically send your vacancy information to the
      government&#x27;s{' '}
      <a href="https://www.mychild.gov.au/" target="_blank" rel="noopener noreferrer">
        MyChild
      </a>{' '}
      website.
    </Note>

    <fieldset>
      <legend>Days where you have vacancies</legend>
      <div className="week">
        {daysOfWeek.map((day, i) => {
          const dayValue = String(day.label).toLowerCase()
          const inputName = 'vacancies.' + dayValue
          const value = vacanciesForDay(values.vacancies, day)

          return (
            <MyChildDay key={'day' + i} day={day} inputName={inputName}>
              <FormCheckbox
                label={day.label}
                name={inputName}
                value={value}
                onChange={onChange}
                loading={loading}
              />
            </MyChildDay>
          )
        })}
      </div>
    </fieldset>
  </div>
)

export default UpdateMyChildFormFields



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccs-registrations/actions/update-myChild/form.jsx